import React from 'react';

import { ActionButton, DirectionButton, Divider, Title, LoadingShimmer } from '@icarros/ids-react';

import { HeaderFilter } from './HeaderFilter';
import { PhoneScamNotify } from '../../components/PhoneScamNotify';

import { pushSellerPFDashboardEvent } from '../../../utils/pushToDataLayer';

import { HeaderBreadcrumbsContainer, HeaderContainer, HeaderWrapper } from './style';

import 'swiper/swiper.min.css';
interface HeaderProps {
  hasAds: boolean;
  isShimmering: boolean;
}

export function Header({ hasAds, isShimmering }: HeaderProps): JSX.Element {
  return (
    <HeaderWrapper hasAds={isShimmering || hasAds}>
      <HeaderBreadcrumbsContainer>
        <DirectionButton text="meu icarros" variant="neutral" weight="small" />
      </HeaderBreadcrumbsContainer>
      <HeaderContainer isShimmering={isShimmering}>
        <LoadingShimmer show={isShimmering} width="162px" height="32px">
          <Title>meus anúncios</Title>
        </LoadingShimmer>

        <LoadingShimmer show={isShimmering} width="24px" height="24px" variant="square">
          <ActionButton
            text="criar anúncio"
            iconName="itaufonts_mais"
            contrast="default"
            weight="medium"
            variant="neutral"
            onClick={() => {
              pushSellerPFDashboardEvent('criar anúncio');
              window.open('/vender/', '_blank');
            }}
          />
        </LoadingShimmer>
      </HeaderContainer>
      <PhoneScamNotify
        handleCardClick={() =>
          pushSellerPFDashboardEvent('confira mais dicas', 'seguranca', {
            location: 'meus anúncios'
          })
        }
        handleMainButtonModalClick={() =>
          pushSellerPFDashboardEvent('entendi', 'modal seguranca', {
            location: 'meus anúncios'
          })
        }
        handleCloseModalClick={() =>
          pushSellerPFDashboardEvent('fechar', 'modal seguranca', {
            location: 'meus anúncios'
          })
        }
      />
      <HeaderFilter isShimmering={isShimmering} />
      <Divider variant="neutral" contrast="default" size="soft" weight="light" />
    </HeaderWrapper>
  );
}
